import styled, { css } from 'styled-components';
import { BlurBox } from '../../index';
import { mobile, tv } from 'app/device';

export const Wrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

export const MessageBox = styled(BlurBox)`
    border-radius: 20px;
    max-width: 765px;
    margin: 0 auto;
    font-size: 1.25rem;
    padding: 24px;

    ${mobile(css`
        padding: 14px;
        font-size: 1.125rem;
    `)}

    ${tv(css`
        max-width: 40%;
    `)}
`;

export const BuildVersion = styled.div`
    line-height: 1.5rem;
    margin-bottom: 1.5rem;
    width: 100%;
    text-align: left;

    ${mobile(css`
        margin-bottom: 0;
    `)}
`;

export const SupportLink = styled.a`
    color: #ffda9f;
    font-style: italic;
`;

export const QrCodeWrapper = styled.div`
    margin: 25px 0 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
`;

export const QrCode = styled.div`
    margin-top: 1rem;
`;
